import { connect } from 'react-redux';
import React from 'react';
import {
  RouterContainer as SourceRouterContainer,
  // mapStateToProps,
  mapDispatchToProps,
} from 'SourceComponent/Router/Router.container';
import Router from './Router.component';
import "sticky-sidebar/dist/sticky-sidebar";

export {
  // mapStateToProps,
  mapDispatchToProps,
};

/** @namespace Component/Router/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
  isLoading: state.ConfigReducer.isLoading,
  default_description: state.ConfigReducer.default_description,
  default_keywords: state.ConfigReducer.default_keywords,
  default_title: state.ConfigReducer.default_title,
  title_prefix: state.ConfigReducer.title_prefix,
  title_suffix: state.ConfigReducer.title_suffix,
  meta_title: state.MetaReducer.title,
  device: state.ConfigReducer.device,
  isOffline: state.OfflineReducer.isOffline,
  isBigOffline: state.OfflineReducer.isBig,
  status_code: state.MetaReducer.status_code,
  base_link_url: state.ConfigReducer.base_link_url,
  head_includes: state.ConfigReducer.head_includes,
  totals: state.CartReducer.cartTotals,
  customer: state.MyAccountReducer.customer,
});

export class RouterContainer extends SourceRouterContainer {
  containerProps() {
    const { isBigOffline, setBigOfflineNotice, head_includes, totals, customer } = this.props;
    const { isOnlyMainItems, currentUrl } = this.state;

    return {
      isBigOffline,
      setBigOfflineNotice,
      isOnlyMainItems,
      currentUrl,
      head_includes,
      totals,
      customer
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);

    window.scrollTo(0, 0);

    // document.head.innerHTML += `${this.props.head_includes}`;

    // facebook meta tag
    const fmeta = document.createElement('meta');
    fmeta.content = "5fm982hrasdwyrd93qwtjjmbb0qb3l";
    fmeta.name = "facebook-domain-verification";
    document.head.appendChild(fmeta);

    // meta tag
    const meta1 = document.createElement('meta');
    meta1.content = "cedc7533dc054668043316815c7fb570";
    meta1.name = "p:domain_verify";
    document.head.appendChild(meta1);

    const meta2 = document.createElement('meta');
    meta2.content = "bC7AlkfM9He9je0BEIBWWhVRBtr";
    meta2.name = "google-site-verification";
    document.head.appendChild(meta2);

    // Global site tag (gtag.js) - Google Analytics
    const googleAnalytics = document.createElement('script');
    googleAnalytics.src = "https://www.googletagmanager.com/gtag/js?id=AW-460816403";
    googleAnalytics.async = true;
    document.head.appendChild(googleAnalytics);

    // Google Tag Manager (noscript)
    const gtmNoScript = document.createElement('noscript');
    const gtmNoScriptIfram = document.createElement('iframe');
    gtmNoScriptIfram.setAttribute('src', "https://www.googletagmanager.com/ns.html?id=GTM-PQ9P462");
    gtmNoScriptIfram.setAttribute("height", "0");
    gtmNoScriptIfram.setAttribute("width", "0");
    gtmNoScriptIfram.setAttribute("style", "display:none;visibility:hidden");
    gtmNoScript.appendChild(gtmNoScriptIfram);
    document.head.appendChild(gtmNoScript);

    // Google Tag Manager (script)
    const gtmScript = document.createElement('script');
    const gtmScriptFunction = `(function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
              'gtm.start':
                new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', 'GTM-PQ9P462');`;
    gtmScript.innerHTML += gtmScriptFunction;
    document.head.appendChild(gtmScript);

    // GTM dataLayer
    const gtmDataLayer = document.createElement('script');
    const gtmDataLayerFunction = `window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', 'AW-460816403');`;
    gtmDataLayer.innerHTML += gtmDataLayerFunction;
    document.head.appendChild(gtmDataLayer);

    // Meta Pixel Code
    const metaPixelCode = document.createElement('script');
    const metaPixelCodeFunction = `!function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
              n.callMethod ?
              n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
          }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1199772723899676');
          fbq('track', 'PageView');`;
    metaPixelCode.innerHTML += metaPixelCodeFunction;
    document.head.appendChild(metaPixelCode);

    const metaPixelCodeNoScript = document.createElement('noscript');
    const metaPixelCodeNoScriptContent = document.createElement('img');
    metaPixelCodeNoScriptContent.setAttribute('src', 'https://www.facebook.com/tr?id=1199772723899676&ev=PageView&noscript=1');
    metaPixelCodeNoScriptContent.setAttribute('width', '1');
    metaPixelCodeNoScriptContent.setAttribute('height', '1');
    metaPixelCodeNoScriptContent.setAttribute('style', 'display:none');

    metaPixelCodeNoScript.appendChild(metaPixelCodeNoScriptContent);
    document.head.appendChild(metaPixelCodeNoScript);

    // apxl script
    const apxl = document.createElement('script');
    apxl.src = "https://apxl.io/script.js";
    document.head.appendChild(apxl);

    const apxlScript = document.createElement('script');
    const apxlScriptContent = `window?.apxlTag?.config("d4044bee-03b8-4b56-a1a1-ee13e0541ba6");`;
    apxlScript.innerHTML += apxlScriptContent;
    document.head.appendChild(apxlScript);

    // Hotjar Tracking Code
    // const HotjarScript = document.createElement('script');
    // const HotjarScriptContent = `(function (h, o, t, j, a, r) {
    //         h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
    //         h._hjSettings = { hjid: 3412977, hjsv: 6 };
    //         a = o.getElementsByTagName('head')[0];
    //         r = o.createElement('script'); r.async = 1;
    //         r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    //         a.appendChild(r);
    //       })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');`;
    // HotjarScript.innerHTML += HotjarScriptContent;
    // document.head.appendChild(HotjarScript);

    // Googl Tag
    const googleTag = document.createElement('script');
    googleTag.src = "https://www.googletagmanager.com/gtag/js?id=G-CEJB06PFC7";
    googleTag.async = true;
    document.head.appendChild(googleTag);

    const googleTagScript = document.createElement('script');
    const googleTagScriptContent = `window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'G-CEJB06PFC7'); `;
    googleTagScript.innerHTML += googleTagScriptContent;
    document.head.appendChild(googleTagScript);

    // G Tag
    const gTag = document.createElement('script');
    gTag.src = "https://www.googletagmanager.com/gtag/js?id=G-M1SZMNZFD1";
    gTag.async = true;
    document.head.appendChild(gTag);

    const gTagScript = document.createElement('script');
    const gTagScriptContent = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-M1SZMNZFD1');`;
    gTagScript.innerHTML += gTagScriptContent;
    document.head.appendChild(gTagScript);

    // LiveChat code
    const liveChatCode = document.createElement('script');
    const liveChatCodeFunction = `window.__lc = window.__lc || {};
        window.__lc.license = 14939271;
        ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)};
        var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){
        i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},
        get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");
        return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){
        var n=t.createElement("script");
        n.async=!0,n.type="text/javascript",
        n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};
        !n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))`;
    liveChatCode.innerHTML += liveChatCodeFunction;
    document.head.appendChild(liveChatCode);

    const liveChatNoScript = document.createElement('noscript');
    const liveChatNoScriptContent1 = document.createElement('a');
    liveChatNoScriptContent1.setAttribute('href', 'https://www.livechat.com/chat-with/14939271/');
    liveChatNoScriptContent1.setAttribute('rel', 'nofollow');
    liveChatNoScriptContent1.innerHTML = "Chat with us";

    const liveChatNoScriptContent2 = document.createElement('a');
    liveChatNoScriptContent2.setAttribute('href', 'https://www.livechat.com/?welcome');
    liveChatNoScriptContent2.setAttribute('rel', 'noopener nofollow');
    liveChatNoScriptContent2.setAttribute('target', '_blank');
    liveChatNoScriptContent2.innerHTML = "LiveChat";

    liveChatNoScript.appendChild(liveChatNoScriptContent1);
    liveChatNoScript.innerHTML += ", powered by ";
    liveChatNoScript.appendChild(liveChatNoScriptContent2);
    document.head.appendChild(liveChatNoScript);

    const adrollScript = document.createElement("script");
    adrollScript.type = "text/javascript";
    adrollScript.innerHTML = `adroll_adv_id = "LLY5E5MQHRFULHJMUAUASA";
        adroll_pix_id = "GXGVQZD45RF4PJRWSNCE3X";
        adroll_version = "2.0";
        (function (w, d, e, o, a) {
            w.__adroll_loaded = true; w.adroll = w.adroll || []; w.adroll.f = ['setProperties', 'identify', 'track']; var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js"; for (a = 0; a < w.adroll.f.length; a++) { w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function (n) { return function () { w.adroll.push([n, arguments]) } })(w.adroll.f[a]) } e = d.createElement('script'); o = d.getElementsByTagName('script')[0]; e.async = 1; e.src = roundtripUrl; o.parentNode.insertBefore(e, o);
        })(window, document); adroll.track("pageView");`;
    document.head.appendChild(adrollScript);

    // omnisend script
    const omnisend = document.createElement('script');
    const omnisendFunction = ` window.omnisend = window.omnisend || [];
        omnisend.push(["accountID", "660f1ccfd540d336d803eb08"]);
        omnisend.push(["track", "$pageViewed"]);
        !function(){var e=document.createElement("script");
        e.type="text/javascript",e.async=!0,
        e.src="https://omnisnippet1.com/inshop/launcher-v2.js";
        var t=document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(e,t)}();`;
    omnisend.innerHTML += omnisendFunction;
    document.head.appendChild(omnisend);

    // hotjar (script)
    const hotjarScript = document.createElement('script');
    const hotjarScriptFunction = `(function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:3412977,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    hotjarScript.innerHTML += hotjarScriptFunction;
    document.head.appendChild(hotjarScript);

    // cookie script
    const cookieScript = document.createElement('script');
    cookieScript.src = "https://cdn-cookieyes.com/client_data/9ac01ea2851969fa2ab3df25/script.js";
    cookieScript.id = "cookieyes";
    cookieScript.type = "text/javascript";
    document.head.appendChild(cookieScript);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RouterContainer);
